import InventoryManagementDefinitionForm from './InventoryManagementDefinitionForm';

export default InventoryManagementDefinitionForm;



// WEBPACK FOOTER //
// ./src/components/forms/InventoryManagementDefinitionForm/index.jsx